import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    title: 'title-4 @hactive:underlined py-2'
  }
} satisfies RecursivePartial<CMSConfig['megaMenuL2Desktop']>
